/* 앱 입력칸은 core InputText · PasswordInput · Textarea 를 쓴다(h-12 · text-c15 · 포커스 테두리 violet).
   core 규격 15px 는 iOS 에서 포커스 때 화면이 확대되므로 600px 이하에서만 16px 로 올린다.
   변형(max-over6:) 유틸리티는 기본 유틸리티 뒤에 출력되어 cn() 이 병합하지 않아도 확실히 이긴다. */
export const INPUT_ZOOM_SAFE = { input: 'max-over6:text-c16' }
export const TEXTAREA_ZOOM_SAFE = { textarea: 'max-over6:text-c16' }
